import { supabase } from '../lib/supabase';

const toCamelCase = (obj) => {
  if (!obj) return obj;
  if (Array.isArray(obj)) return obj?.map(toCamelCase);
  if (typeof obj !== 'object') return obj;

  return Object.keys(obj)?.reduce((acc, key) => {
    const camelKey = key?.replace(/_([a-z])/g, (_, letter) => letter?.toUpperCase());
    acc[camelKey] = toCamelCase(obj?.[key]);
    return acc;
  }, {});
};

const toSnakeCase = (obj) => {
  if (!obj) return obj;
  if (Array.isArray(obj)) return obj?.map(toSnakeCase);
  if (typeof obj !== 'object') return obj;

  return Object.keys(obj)?.reduce((acc, key) => {
    const snakeKey = key?.replace(/[A-Z]/g, (letter) => `_${letter?.toLowerCase()}`);
    acc[snakeKey] = toSnakeCase(obj?.[key]);
    return acc;
  }, {});
};

export const projectService = {
  async getActiveProjects() {
    const { data, error } = await supabase?.from('projects')?.select('*')?.in('status', ['active', 'completed'])?.order('created_at', { ascending: false });

    if (error) throw error;
    return toCamelCase(data);
  },

  async getAllProjects() {
    const { data, error } = await supabase?.from('projects')?.select('*')?.order('created_at', { ascending: false });

    if (error) throw error;
    return toCamelCase(data);
  },

  async getProjectById(id) {
    const { data, error } = await supabase?.from('projects')?.select('*')?.eq('id', id)?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async createProject(projectData) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const snakeData = toSnakeCase({
      ...projectData,
      createdBy: user?.id
    });

    const { data, error } = await supabase?.from('projects')?.insert(snakeData)?.select()?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async updateProject(id, projectData) {
    const snakeData = toSnakeCase(projectData);

    const { data, error } = await supabase?.from('projects')?.update(snakeData)?.eq('id', id)?.select()?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async deleteProject(id) {
    const { error } = await supabase?.from('projects')?.delete()?.eq('id', id);

    if (error) throw error;
  }
};
